import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ScrollArea } from "@mantine/core";
import { CodeEditor } from "../../components/CodeEditor.js";
import { useAppAction } from "../../hooks/redux.js";
import { changeLayerConfig } from "../../reducers/layersReducer.js";
import { useCallback } from "react";
import { Event } from "../../constants/events.js";
import { useStyleEditor } from "../../components/StyleEditorContext.js";
import { LayerConfigHeader } from "./LayerConfigHeader.js";
import { LayerConfigControls } from "./LayerConfigControls.js";
import { SecondaryPanel } from "../../components/SidePanel.js";
export const LayerConfigCode = ({ layer }) => {
    const { captureEvent } = useStyleEditor();
    const changeLayer = useAppAction(changeLayerConfig);
    const handleChange = useCallback((value) => {
        if (!value)
            return;
        const config = JSON.parse(value);
        captureEvent(Event.ChangeLayerConfig, {
            id: layer.id,
            config: layer,
        });
        changeLayer({
            id: layer.id,
            config: config,
            type: "code",
        });
    }, [layer, captureEvent, changeLayer]);
    return (_jsxs(SecondaryPanel, { children: [_jsx(LayerConfigHeader, { layer: layer }), _jsx(LayerConfigControls, { layer: layer }), _jsx(ScrollArea, { h: "calc(100% - 100px)", children: _jsx(CodeEditor, { onChange: handleChange, value: JSON.stringify(layer, null, 2) }) })] }));
};
